export function getCalendarItemCardStepYesNoValue({ type, yesno }) {
  return yesno === type ? null : type
}

export function getIsCalendarItemCardStepSaving(loadingType) {
  return loadingType !== null
}
